<template>
  <el-dialog
    :title="'📋 管理部门员工绩效考核评价表'"
    :visible.sync="dialogVisible"
    width="90%"
    top="2vh"
    :close-on-click-modal="false"
    custom-class="review-dialog"
  >
    <!-- 步骤指示器 -->
    <div class="step-indicator">
      <div class="step-node done">
        <div class="step-circle">1</div>
        <span class="step-label">员工填写</span>
      </div>
      <div class="step-arrow">→</div>
      <div :class="['step-node', step === 2 ? 'active' : 'done']">
        <div class="step-circle">2</div>
        <span class="step-label">部门领导审核打分</span>
      </div>
      <div class="step-arrow">→</div>
      <div :class="['step-node', step === 3 ? 'active' : '']">
        <div class="step-circle">3</div>
        <span class="step-label">上级复核</span>
      </div>
    </div>

    <!-- 基本信息 -->
    <div class="basic-info-card">
      <div class="info-row">
        <div class="info-item">
          <span class="info-label">填表日期：</span>
          <span class="info-value">{{ currentRow.fillDate || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">被考核人：</span>
          <span class="info-value">{{ currentRow.userName || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">部门：</span>
          <span class="info-value">{{
            currentRow.departmentName || '--'
          }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-item">
          <span class="info-label">岗位：</span>
          <span class="info-value">{{ currentRow.positionName || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">考核年度：</span>
          <span class="info-value">{{
            currentRow.assessmentYear || '--'
          }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">考核类型：</span>
          <span class="info-value">{{
            currentRow.assessmentType || '--'
          }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-item">
          <span class="info-label">周期细分：</span>
          <span class="info-value">{{ currentRow.periodDetail || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">部门领导：</span>
          <span class="info-value">{{
            currentRow.selectedDeptLeaderName || '--'
          }}</span>
        </div>
      </div>
    </div>

    <!-- 指标打分表格 -->
    <div class="indicator-table-wrapper">
      <el-table :data="currentRow.items" border style="width: 100%">
        <el-table-column
          prop="indicatorType"
          label="指标分类"
          width="120"
          align="center"
        />
        <el-table-column
          prop="targetRequirement"
          label="目标要求"
          min-width="200"
        />
        <el-table-column
          prop="employeeResult"
          label="员工自述落实事例"
          min-width="250"
        />
        <el-table-column
          prop="weightScore"
          label="权重分"
          width="100"
          align="center"
        />
        <el-table-column label="领导打分" width="200" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.deptLeaderScore"
              :min="0"
              :max="scope.row.weightScore"
              :step="1"
              size="small"
              :disabled="step === 3"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 亮点评分和扣分项 -->
    <div class="bonus-deduct-section">
      <div class="bonus-card">
        <div style="display: flex; justify-content: space-between">
          <div class="section-title">✨ 亮点评分（附加分 0-10分）</div>
          <div style="color: #1f4e43">权重分：10</div>
        </div>
        <div class="section-content">
          <div class="highlight-desc">
            <span class="label">亮点描述：</span>
            <span class="value">{{
              currentRow.employeeHighlightDesc || '无'
            }}</span>
          </div>
          <div class="leader-score-input">
            <label>领导评定分数：</label>
            <el-input-number
              v-model="currentRow.deptLeaderBonusScore"
              :min="0"
              :max="10"
              :step="1"
              size="small"
              :disabled="step === 3"
            />
          </div>
        </div>
      </div>

      <div class="deduct-card">
        <div class="section-title">⚠️ 扣分项（失误/否决 扣分，0~20）</div>
        <div class="section-content">
          <div class="deduct-reason">
            <span class="label">扣分事由：</span>
            <span class="value">{{
              currentRow.employeeDeductDesc || '无'
            }}</span>
          </div>
          <div class="leader-score-input">
            <label>领导扣分（负值）：</label>
            <el-input-number
              v-model="currentRow.deptLeaderDeductScore"
              :min="0"
              :max="20"
              :step="1"
              size="small"
              :disabled="step === 3"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 考核总分 -->
    <div class="total-score-section">
      <div class="score-formula">
        🏆 考核总分(自动计算) = 指标得分 + 亮点评分 - 扣分项
      </div>
      <div class="total-score-display">
        <span class="score-value">{{ totalScore.toFixed(2) }}</span>
      </div>
    </div>

    <!-- 部门领导意见 -->
    <div class="leader-comment-section">
      <div class="comment-row">
        <div class="comment-label">部门领导意见：</div>
        <el-input
          v-model="currentRow.deptLeaderComment"
          type="textarea"
          :rows="3"
          placeholder="请填写评语"
          maxlength="500"
          show-word-limit
          :disabled="step === 3"
        />
      </div>
      <div class="signature-row">
        <div class="signature-item">
          <span class="label">姓名：</span>
          <el-input
            v-model="currentRow.selectedDeptLeaderName"
            size="small"
            style="width: 120px"
            disabled
          />
        </div>
        <div class="signature-item">
          <span class="label">日期：</span>
          <el-date-picker
            v-model="currentRow.deptLeaderSignDate || leaderDate"
            type="date"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 140px"
            disabled
          />
        </div>
      </div>
      <div class="comment-row" style="margin-top: 20px">
        <div class="comment-label">选择复核领导：</div>
        <span class="info-value">
          <el-select
            v-model="currentRow.gmName"
            placeholder="请选择复核领导"
            style="width: 100%"
            @change="handleDeptLeaderChange"
            :disabled="step === 3"
          >
            <el-option
              v-for="leader in deptLeaders"
              :key="leader.value"
              :label="leader.label"
              :value="leader.value"
            />
          </el-select>
        </span>
      </div>
    </div>

    <!-- 复核领导意见 -->
    <div class="leader-comment-section" v-if="step === 3">
      <div class="comment-row">
        <div class="comment-label">复核领导意见：</div>
        <el-input
          v-model="currentRow.gmComment"
          type="textarea"
          :rows="3"
          placeholder="请填写评语"
          maxlength="500"
          show-word-limit
        />
      </div>
      <div class="signature-row">
        <div class="signature-item">
          <span class="label">姓名：</span>
          <el-input
            v-model="currentRow.gmName"
            size="small"
            style="width: 120px"
            disabled
          />
        </div>
        <div class="signature-item">
          <span class="label">日期：</span>
          <el-date-picker
            v-model="currentRow.gmSignDate || leaderDate"
            type="date"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 140px"
            disabled
          />
        </div>
        <div class="leader-score-input" style="position: absolute; right: 40px">
          <label style="color: #d48806">复核领导打分（打分区间 0~100）：</label>
          <el-input-number
            v-model="currentRow.gmConfirmScore"
            :min="0"
            :max="100"
            :step="1"
            size="small"
          />
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <div class="footer-note">
        审核时请对每个指标打分，系统自动计算总分+亮点扣分。
      </div>
      <div class="action-buttons" v-if="step === 3">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleFinalSubmit">
          ✅ 完成打分 & 复核通过
        </el-button>
      </div>
      <div class="action-buttons" v-else>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="danger" @click="handleReject">驳 回</el-button>
        <el-button type="primary" @click="handleSubmit">
          ✅ 完成打分 & 提交复核
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getCompaniesUsers, reviewReject } from '@/API/apply/apply';

export default {
  name: 'ReviewDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
    step: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      currentRow: {},
      leaderDate: new Date().toISOString().split('T')[0],
      currentCompanyId: JSON.parse(localStorage.getItem('ordinaryUser'))
        ?.userDetail?.companyInfo?.companyId,
      deptLeaders: [],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    totalScore() {
      // 计算每项指标得分之和（直接求和，不加权）
      const indicatorScoreSum = this.currentRow.items.reduce((sum, item) => {
        const score = Number(item.deptLeaderScore) || 0;
        return sum + score;
      }, 0);

      // 总分 = 每项指标得分之和 + 亮点评分 + 扣分项
      const baseScore =
        indicatorScoreSum +
        this.currentRow.deptLeaderBonusScore -
        this.currentRow.deptLeaderDeductScore;
      return baseScore;
    },
  },
  watch: {
    visible(val) {
      if (val && this.rowData && Object.keys(this.rowData).length > 0) {
        this.initDialogData();
      }
    },
  },
  mounted() {
    this.getCompaniesUsers();
  },
  methods: {
    getCompaniesUsers() {
      getCompaniesUsers(this.currentCompanyId).then((res) => {
        this.deptLeaders = res.data.map((item) => ({
          value: item.userId,
          label: item.username,
        }));
      });
    },
    initDialogData() {
      // 初始化当前行数据
      this.currentRow = { ...this.rowData };
      console.log('this.rowData', this.currentRow);
      this.leaderDate = new Date().toISOString().split('T')[0];
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleReject() {
      // 验证驳回原因
      if (
        !this.currentRow.deptLeaderComment ||
        !this.currentRow.deptLeaderComment.trim()
      ) {
        this.$message.warning('请在部门领导意见中填写驳回原因');
        return;
      }

      // 确认驳回
      this.$confirm(
        '确认驳回该绩效考核？驳回后将返回给员工重新填写。',
        '驳回确认',
        {
          confirmButtonText: '确认驳回',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          const param = {
            id: this.currentRow.id,
            operatorUserId: this.currentRow.selectedDeptLeaderUserId,
            rejectTo: this.currentRow.userId,
            comment: this.currentRow.deptLeaderComment,
          };

          reviewReject(param, param.id)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('驳回成功');
                // 关闭弹框
                this.handleClose();
                // 触发父组件的 query 事件，调用 handlePendingReviewQuery 方法刷新数据
                this.$emit('query');
              } else {
                this.$message.error(res.message || '驳回失败');
              }
            })
            .catch((error) => {
              console.error('驳回失败:', error);
              this.$message.error('驳回失败，请重试');
            });
        })
        .catch(() => {
          // 用户取消驳回
        });
    },
    handleDeptLeaderChange(val) {
      this.deptLeaders.map((item) => {
        console.log('val', val, item);
        if (val === item.value) {
          this.currentRow.gmName = item.label;
          this.currentRow.gmId = item.value;
        }
      });
    },
    handleSubmit() {
      // 验证
      if (
        !this.currentRow.deptLeaderComment ||
        !this.currentRow.deptLeaderComment.trim()
      ) {
        this.$message.warning('请填写部门领导评语');
        return;
      }
      // 验证指标打分
      const hasUnscoredIndicator = this.currentRow.items.some(
        (item) =>
          item.deptLeaderScore === null || item.deptLeaderScore === undefined,
      );
      if (hasUnscoredIndicator) {
        this.$message.warning('请为所有考核指标打分');
        return;
      }
      if (!this.currentRow.gmId || this.currentRow.gmId === '') {
        this.$message.warning('请选择复核领导');
        return;
      }

      // 构建提交数据
      let newArr = this.currentRow.items.map((item) => {
        return {
          itemId: item.id,
          deptLeaderScore: item.deptLeaderScore,
        };
      });
      const submitData = {
        id: this.currentRow.id,
        managerUserId: this.currentRow.gmId,
        managerName: this.currentRow.gmName,
        comment: this.currentRow.deptLeaderComment,
        signDate: new Date().toISOString().split('T')[0],
        bonusScore: this.currentRow.deptLeaderBonusScore,
        deductScore: this.currentRow.deptLeaderDeductScore,
        confirmScore: '',
        items: newArr,
      };
      // 发出提交事件
      this.$emit('submit', submitData);
    },
    handleFinalSubmit() {
      // 验证指标打分
      const hasUnscoredIndicator = this.currentRow.items.some(
        (item) =>
          item.deptLeaderScore === null || item.deptLeaderScore === undefined,
      );
      if (hasUnscoredIndicator) {
        this.$message.warning('请为所有考核指标打分');
        return;
      }
      // 验证
      if (!this.currentRow.gmComment || !this.currentRow.gmComment.trim()) {
        this.$message.warning('请填写复核领导评语');
        return;
      }

      // 构建提交数据
      let newArr = this.currentRow.items.map((item) => {
        return {
          itemId: item.id,
          deptLeaderScore: item.deptLeaderScore,
        };
      });

      const submitData = {
        id: this.currentRow.id,
        comment: this.currentRow.gmComment,
        signDate: new Date().toISOString().split('T')[0],
        bonusScore: this.currentRow.deptLeaderBonusScore,
        deductScore: this.currentRow.deptLeaderDeductScore,
        confirmScore: this.currentRow.gmConfirmScore,
        items: newArr,
      };
      console.log('=== 提交的完整数据 ===', submitData);
      // 发出提交事件
      this.$emit('submit', submitData);
    },
  },
};
</script>

<style scoped lang="less">
.review-dialog {
  .step-indicator {
    background: #f8faf4;
    padding: 12px 28px;
    display: flex;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
    border-bottom: 1px solid #dee6da;
    font-size: 14px;

    .step-node {
      display: flex;
      align-items: center;
      gap: 10px;

      .step-circle {
        width: 32px;
        height: 32px;
        background: #cfdec8;
        border-radius: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #2f5434;
      }

      &.active .step-circle {
        background: #2b6e3c;
        color: white;
        box-shadow: 0 0 0 3px rgba(43, 110, 60, 0.2);
      }

      &.done .step-circle {
        background: #5c8f60;
        color: white;
      }

      .step-label {
        font-weight: 500;
      }

      &.active .step-label {
        color: #2b6e3c;
        font-weight: 600;
      }
    }

    .step-arrow {
      color: #8fa388;
      font-size: 18px;
    }
  }

  .basic-info-card {
    background: #f8faf4;
    border-radius: 12px;
    padding: 20px;
    margin: 20px 0;

    .info-row {
      display: flex;
      gap: 40px;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .info-item {
        flex: 1;

        .info-label {
          font-size: 13px;
          color: #666;
          font-weight: 500;
        }

        .info-value {
          font-size: 13px;
          color: #333;
          font-weight: 600;
        }
      }
    }
  }

  .indicator-table-wrapper {
    margin: 20px 0;

    /deep/ .el-table {
      font-size: 13px;

      th {
        background: #f5f7fa;
        color: #1f4e43;
        font-weight: 600;
      }
    }
  }

  .bonus-deduct-section {
    display: flex;
    gap: 20px;
    margin: 20px 0;

    .bonus-card {
      flex: 1;
      background: #fffbe6;
      border: 1px solid #ffe58f;
      border-radius: 12px;
      padding: 16px;

      .section-title {
        font-size: 14px;
        font-weight: 600;
        color: #d48806;
        margin-bottom: 12px;
      }

      .section-content {
        .highlight-desc,
        .deduct-reason {
          margin-bottom: 12px;

          .label {
            font-size: 13px;
            color: #666;
            font-weight: 500;
          }

          .value {
            font-size: 13px;
            color: #333;
          }
        }

        .leader-score-input {
          display: flex;
          align-items: center;
          gap: 10px;

          label {
            font-size: 13px;
            color: #666;
            white-space: nowrap;
          }
        }
      }
    }

    .deduct-card {
      flex: 1;
      background: #fff2f0;
      border: 1px solid #ffccc7;
      border-radius: 12px;
      padding: 16px;

      .section-title {
        font-size: 14px;
        font-weight: 600;
        color: #cf1322;
        margin-bottom: 12px;
      }

      .section-content {
        .highlight-desc,
        .deduct-reason {
          margin-bottom: 12px;

          .label {
            font-size: 13px;
            color: #666;
            font-weight: 500;
          }

          .value {
            font-size: 13px;
            color: #333;
          }
        }

        .leader-score-input {
          display: flex;
          align-items: center;
          gap: 10px;

          label {
            font-size: 13px;
            color: #666;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .total-score-section {
    background: #f0f9eb;
    border: 1px solid #d9f7be;
    border-radius: 12px;
    padding: 20px;
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .score-formula {
      font-size: 14px;
      color: #389e0d;
      font-weight: 500;
    }

    .total-score-display {
      .score-value {
        font-size: 32px;
        font-weight: bold;
        color: #1e6f5c;
      }
    }
  }

  .leader-comment-section {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
    margin: 20px 0;

    .comment-row {
      margin-bottom: 16px;

      .comment-label {
        font-size: 14px;
        color: #333;
        font-weight: 600;
        margin-bottom: 8px;
        display: block;
      }
    }

    .signature-row {
      display: flex;
      gap: 30px;
      align-items: center;

      .signature-item {
        display: flex;
        align-items: center;
        gap: 8px;

        .label {
          font-size: 13px;
          color: #666;
          white-space: nowrap;
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .footer-note {
      font-size: 12px;
      color: #6b8a9b;
    }

    .action-buttons {
      display: flex;
      gap: 12px;
    }
  }
}
</style>
